import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem("user"));

  // ❌ login nahi ya admin nahi
  if (!user || user.role !== "admin") {
    return <Navigate to="/login" replace />;
  }

  // ✅ exporter = admin allowed
  return children;
};

export default AdminRoute;
